"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var axiosClientFactory_1 = require("./utils/axiosClientFactory");
var adonis_client_1 = require("@utex/adonis-client");
var BaseApiClient = (function () {
    function BaseApiClient(options, logger, schema, getTokens, getTraceId) {
        this.clients = {};
        this.schema = schema;
        if (!options.logger) {
            this.config = options;
            this.logger = logger;
            if (this.config.rest) {
                this.clients.rest = axiosClientFactory_1.axiosClientFactory(this.config.rest, undefined, getTraceId);
                this.clients.securedRest = axiosClientFactory_1.axiosClientFactory(this.config.rest, getTokens, getTraceId);
            }
            if (this.config.stream) {
                this.clients.stream = new adonis_client_1.AdonisClient(this.config.stream, this.logger, getTokens);
            }
        }
        else {
            var objectOptions = options;
            this.config = objectOptions.config;
            this.logger = objectOptions.logger;
            if (this.config.rest) {
                this.clients.rest = axiosClientFactory_1.axiosClientFactory(this.config.rest, undefined, objectOptions.getTraceId);
                this.clients.securedRest = axiosClientFactory_1.axiosClientFactory(this.config.rest, objectOptions.getTokens, objectOptions.getTraceId, objectOptions.removeTokens);
            }
            if (this.config.stream) {
                this.clients.stream = new adonis_client_1.AdonisClient(this.config.stream, this.logger, objectOptions.getTokens);
            }
        }
    }
    BaseApiClient.prototype.onLogout = function () {
        if (this.clients.stream) {
            this.clients.stream.logout();
        }
    };
    BaseApiClient.prototype.destroy = function () {
        this.onLogout();
    };
    return BaseApiClient;
}());
exports.BaseApiClient = BaseApiClient;
//# sourceMappingURL=BaseApiClient.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@utex/base-api-sdk/dist/BaseApiClient.js
// module id = 1634
// module chunks = 118